import React, { useState, useEffect, useCallback, useRef } from "react";
import { connect } from 'react-redux'
import { BiEdit } from "react-icons/bi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { Button, Form, Modal } from "react-bootstrap";
import AgGridTable from "../AgGridTable";
import {
    addFunctionsAction,
    updateFunctionsAction,
    deleteFunctionsAction
} from '../../../redux/actions/admin/adminAction';

export const Function = (props) => {
    const gridRef = useRef();

    const [inputData, setInputData] = useState({ 'function': '' })
    const [show, setShow] = useState(false);

    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setInputData({ 'function': '' })
        setShow(false)
    };

    const handleChange = (event) => {
        setInputData((prevstate) => ({
            ...prevstate,
            [event.target.name]: event.target.value
        }))
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if (inputData['id']) {
            props.updateFunction(inputData.id, inputData)
            handleClose()
        }
        else {
            props.addFunction(inputData)
            handleClose()
        }
    };

    const handleSetData = (data) => {
        setInputData(data)
        handleShow()
    }

    const handleDelete = (id) => {
        props.deleteFunction(id)
    }

    const [functionColumnDefs] = useState([
        { headerName: "Id", field: 'id', sort: 'asc' },
        { headerName: "Function", field: 'function', filter: true, },
        {
            headerName: "Actions", field: 'action',
            cellRendererFramework: (params) => <>
                <BiEdit color="blue" size={20} onClick={() => handleSetData(params.data)} cursor='pointer' />
                <RiDeleteBin6Line color="red" size={20} onClick={() => handleDelete(params.data.id)} cursor='pointer' />
            </>,
            cellStyle: { textAlign: 'center' }
        },
    ])


    const defaultColDef = {
        flex: 1,
        floatingFilter: true,
        sortable: true,
        editable: false,
    }

    return (
        <div>
            <div align='right'>
                <button className="btn btn-blue"
                    onClick={() => handleShow()}
                    style={{ marginBottom: "10px" }}>Add</button>
            </div>

            <AgGridTable
                ref={gridRef}
                data={props.functions}
                defaultColDef={defaultColDef}
                columnDefs={functionColumnDefs} />

            {/* Add Form */}
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Functions</Modal.Title>
                </Modal.Header>

                <form onSubmit={handleSubmit}>

                    <Modal.Body>
                        <h3>Function</h3>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="function"
                                name="function"
                                value={inputData.function}
                                onChange={handleChange}
                                placeholder="Function"
                                autoComplete="off"
                            />
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" type="submit">
                            Submit
                        </Button>
                    </Modal.Footer>

                </form>
            </Modal>
        </div >
    )
}

const mapStateToProps = (state) => {
    const functions = state.admin.functions;
    return {
        functions: functions,
    };
};

const mapDispatchToProps = (dispatch, state) => {
    return {
        addFunction: (data) => dispatch(addFunctionsAction(data)),
        updateFunction: (id, data) => dispatch(updateFunctionsAction(id, data)),
        deleteFunction: (id) => dispatch(deleteFunctionsAction(id)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Function);